import React, { useContext, useEffect, useState } from 'react'
import { Col, Form } from 'react-bootstrap'
import { useFetch } from '../../hooks'
import { FormSelectFilter } from '../../components/molecules'
import { WButton } from '../../components/atoms'
import { StudiKwFilterDataContext } from '../../HOC/studiKwFiltersContext'
import { Card, CardBody, CardHeader, Row } from 'reactstrap'

const simpleResponse = ['si', 'no']

export const HomeFilterForm = () => {
	const [brand, setBrand] = useState('')

	const [country, setCountry] = useState('')

	const [industry, setIndustry] = useState('')

	const [mobile, setMobile] = useState('')

	const [studioKwName, setstudioKwName] = useState('')

	const [filteredstudioKwNames, setFilteredstudioKwNames] = useState([])

	const [multiplePositioning, setMultiplePositioning] = useState('')

	const brands = useFetch({ url: 'studiokw/brands/' })

	const countries = useFetch({ url: 'studiokw/countries/' })

	const industries = useFetch({ url: 'studiokw/industries/' })

	const studioKwNames = useFetch({url: 'studiokw/studiokw_names/'})

	const [, , getFilteredData, , actualPage, setActualPage] = useContext(StudiKwFilterDataContext)

	useEffect(() => {
		if (studioKwNames && studioKwNames.data) {
			setFilteredstudioKwNames(studioKwNames.data)
		}
	}, [studioKwNames])

	useEffect(() => {
		if (studioKwNames && studioKwNames.data) {
			const query = studioKwName.toLowerCase()
			setFilteredstudioKwNames(
				studioKwNames.data.filter(name => name.toLowerCase().includes(query)).slice(0,10)
			)
		}
	}, [studioKwName, studioKwNames])
	const handleClearFilters = () => {
		setActualPage(1)
		setBrand('')
		setCountry('')
		setIndustry('')
		setstudioKwName('')
		setMobile('')
		setMultiplePositioning('')
		getFilteredData({ page_size: 10, page: 1})
	}

	const handleApplyFilters = () => {
		setActualPage(1)
		let params = {
			...(brand.length > 0 && { brand: brand }),
			...(country.length > 0 && { country: country }),
			...(industry.length > 0 && { industry: industry }),
			...(mobile.length > 0 && { mobile: mobile === 'si' ? true : false }),
			...(multiplePositioning.length > 0 && {
				multiple_positioning: multiplePositioning === 'si' ? true : false,
			}),
			...(studioKwName.length > 0 && { nome: studioKwName }),
			page_size: 10,
			page: 1,

		}
		getFilteredData(params)
	}

	return (
	<>
		{brands && countries && industries && (
		<div className="pb-8 pt-5 pt-md-8">
			<Row>
			<div className="col">
				<Card className="shadow">
					<CardHeader className="border-0">
						<h1 className="mb-0">Filters</h1>
					</CardHeader>
					<CardBody className="pt-0">
						<Form>
							<Row className="justify-content-center" style={{marginLeft:"80px", marginRight:"80px"}}>
								<Col>
									<Form.Group>
										<Form.Label>Name</Form.Label>
										<Form.Control
											type="text"
											value={studioKwName}
											onChange={(e) => setstudioKwName(e.target.value)}
										/>
										{studioKwName && filteredstudioKwNames.length > 0 && (
											<ul style={{ listStyle: 'none', padding: 0, border: '1px solid #ccc', borderRadius: '4px', marginTop: '5px' }}>
												{filteredstudioKwNames.map((name, index) => (
													<li
														key={index}
														style={{ padding: '5px 10px', cursor: 'pointer' }}
														onClick={() => setstudioKwName(name)}
													>
														{name}
													</li>
												))}
											</ul>
										)}
									</Form.Group>
								</Col>
								<Col>
									<FormSelectFilter
										label={'Brand'}
										value={brand}
										onChange={setBrand}
										data={brands.data}
									/>
								</Col>
								<Col>
									<FormSelectFilter
										label={'Country'}
										value={country}
										onChange={setCountry}
										data={countries.data}
									/>
								</Col>
								<Col>
									<FormSelectFilter
										label={'Industry'}
										value={industry}
										onChange={setIndustry}
										data={industries.data}
									/>
								</Col>
								<Col>
									<FormSelectFilter
										label={'Mobile'}
										value={mobile}
										onChange={setMobile}
										data={simpleResponse}
									/>
								</Col>
							</Row>
						</Form>
					<Row style={{display: "flex", justifyContent: "flex-end", marginRight: "92px"}}>
							<WButton label="Clear Filters" variant="light" onClick={handleClearFilters} />
							<WButton label="Apply" variant="primary" onClick={handleApplyFilters} />
					</Row>
					</CardBody>
					</Card>
					</div>
					</Row>
				</div>
			)}
		</>
	)
}
